import { createNamedStyles } from "../../../../shared/utils";

export const paymentLoadingStyles = createNamedStyles({
  container: {
    my: 6,
    display: "flex",
    justifyContent: "center",
  },
});
